<template>
  <transition>
    <router-view style="min-width: 1200px;" />
  </transition>
</template>

<script>
export default {};
</script>

<style>
</style>
